module.exports = __webpack_public_path__ + "media/images/questionnaire_examples/logo_testing2-e0c874d06b2ac686bff5bedb6d043fca.png";